import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { pickupPointsType } from '../../types';

const initialState: pickupPointsType = {
    pickup_points: [],
    is_loading_pickup_points: false,
};

const pickupPointsSlice = createSlice({
    name: 'pickupPoints',
    initialState,
    reducers: {
        getPickupPointsSuccess: (state, actions: PayloadAction<Array<object>>) => {
            return {
                ...state,
                pickup_points: actions.payload
            };
        },
        isPickupPointsLoading: (state, actions: PayloadAction<boolean>) => {
            return {
                ...state,
                is_loading_pickup_points: actions.payload
            };
        },
    }
});

export const { getPickupPointsSuccess, isPickupPointsLoading } = pickupPointsSlice.actions;

export default pickupPointsSlice.reducer;